import { AllStatuses, AllStatusesTypes } from 'interfaces';
import css from './StatusIndicator.module.scss';
import React from 'react';
import { StatusIndicatorProps } from './StatusIndicator.model';

const statusColorsMap: Record<AllStatusesTypes, string> = {
  [AllStatuses.DRAFT]: 'var(--uui-warning-50)',
  [AllStatuses.NOT_SAVED]: 'var(--uui-secondary-50)',
  [AllStatuses.APPROVED]: 'var(--uui-success-50)',
  [AllStatuses.PUBLISHED]: 'var(--uui-link-visited)',
  [AllStatuses.PENDING_APPROVAL]: 'var(--uui-info-50)',
  [AllStatuses.FAILED]: 'var(--uui-error-50)',
  [AllStatuses.DELIVERED]: 'var(--uui-success-50)',
  [AllStatuses.PENDING]: 'var(--uui-info-50)',
};

export const StatusIndicatorDot = ({ size, status }: StatusIndicatorProps) => (
  <div
    className={css['status-indicator__circle']}
    style={{
      width: `${size}px`,
      background: statusColorsMap[status] ?? 'transparent',
    }}
  />
);
